export const JOINING_DATE = "2022-07-26";

export const OPEN_TO_WORK_STATUS = true;

export const GITHUB_API_HOST_URL = "https://api.github.com";

export const RESUME_DRIVE_URL = "https://drive.google.com/file/d/14f3QXhfkbErhtsGnuvxT5_alKtZ0nBeM/view?usp=sharing"